import React from "react";
import { Link } from "gatsby";
import CalcShape from "../../../assets/images/popular_calc_shape.svg";

import PropTypes from "prop-types";
import "./popularCategories.scss";
import { triggerBuzzClickEvent } from "../../../utils/garfieldHelpers";
import { EVENT_NAMES } from "../../../constants/garfieldEvents";
import { POPULAR_CATEGORIES_DATA } from "./popularCategories.constant";

const PopularCategories = ({
  popularCategories,
  title,
  sectionId,
  source,
  flow,
}) => {
  const handleCategoryClick = (name, uri) => {
    triggerBuzzClickEvent(
      EVENT_NAMES.POPULAR_CATEGORY_CLICKED,
      {
        [POPULAR_CATEGORIES_DATA.NAME]: name,
        [POPULAR_CATEGORIES_DATA.URL]: uri,
      },
      sectionId,
      source,
      flow
    );
  };
  return (
    <div className="popular-categories-wrapper">
      <div className="popular-categories-title rajdhani-font">
        {title}
      </div>
      <div className="popular-categories-data">
        {popularCategories?.map((item, index) => {
          const { name, uri } = item || {};
          return (
            <div
              className="popular-categories-link"
              key={`${title}-${index}`}
            >
              <Link
                to={uri}
                className="category-link"
                onClick={() =>
                  handleCategoryClick(name, uri)
                }
              >
                {name}
                <img
                  className="link-img"
                  src={CalcShape}
                  alt={`popular-category ${title}`}
                />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

PopularCategories.propTypes = {
  popularCategories: PropTypes.object,
  title: PropTypes.string,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default PopularCategories;
